// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1_th6","cell":"ColumnAccessor_cell__WEdLb","firstCellAccent":"ColumnAccessor_firstCellAccent__1YUGx"};